import React from "react";
import { useTranslation } from "react-i18next";
import "./Languages.css";

function Languages() {
  const { t } = useTranslation();

  const languages = [
    { 
      code: "FR", 
      name: t("lang_fr_name"), 
      desc: t("lang_fr_desc") 
    },
    { 
      code: "EN", 
      name: t("lang_en_name"), 
      desc: t("lang_en_desc") 
    },
    { 
      code: "DE", 
      name: t("lang_de_name"), 
      desc: t("lang_de_desc") 
    },
  ];

  return (
    <div className="languages-container-premium">
      <div className="languages-monolith">
        {languages.map((lang, index) => (
          <div key={index} className="lang-row">
            <div className="lang-indicator">
              <span className="lang-code-minimal">{lang.code}</span>
            </div>
            
            <div className="lang-info">
              <h3 className="lang-label">{lang.name}</h3>
              <p className="lang-detail">{lang.desc}</p>
            </div>
            
            {/* La petite touche modernité : un trait de lumière au hover */}
            <div className="lang-scanner"></div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Languages;